export default defineNuxtPlugin(async (nuxtApp) => {
    const { $i18n } = nuxtApp
    const cookieOptions = {
        parseJSON: false,
    }
    const router = useRoute()

    const localeParam = router.path?.split('/')[1]

    const newLocaleValid = $i18n.locales.value?.find(
        (item) => item.code === localeParam
    )?.code

    const lang =
        newLocaleValid ||
        useCookie('lang', cookieOptions).value ||
        $i18n.defaultLocale

    if (import.meta.server) {
        useState('langstate', () => lang)
        if (lang && $i18n.locale.value !== lang) {
            await $i18n?.setLocale(lang)
        }
    }
    if (import.meta.client) {
        useCookie('lang').value = lang
    }
})
